export const MARITAL_STATUS = [
  { text: 'Single', value: 'Single' },
  { text: 'Married', value: 'Married' },
  { text: 'Divorced', value: 'Divorced' },
  { text: 'Widowed', value: 'Widowed' },
  { text: 'Separated', value: 'Separated' },
  { text: 'Not Applicable', value: 'Not Applicable' },
];
export default MARITAL_STATUS;



// WEBPACK FOOTER //
// ./src/constants/maritalStatus.js